import Rest from '@/services/Rest';

/**
 * @typedef {MemberKitService}
 */
export default class MemberKitService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/memberkit'
}
